const breakpoints = [512, 768, 1024, 1440];

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

module.exports = breakpoints;
